import React, { useState } from 'react';
import QuotesEditScreen from './QuotesEditScreen';
import Screen from '../../components/layout/Screen';
import { ICONS } from '../../common/icons/icons';
import Animated from '../../components/AnimatedComponent';
import { useModal } from '../../common/context/ModalProvider';
import AnimatedBox from '../../components/AnimatedBox';
import ScrollableContainer from '../../components/ScrollableContainer';
import SectionTitle from '../../components/SectionTitle';

const QuotesListScreen = () => {
  const { showModal } = useModal();
  const [search, setSearch] = useState('');

  const onOpenAddModal = () => {
    showModal({
      title: 'Add book',
      content: <QuotesEditScreen />,
      onConfirm: () => {
        alert('User confirm!');
      },
    });
  };

  return (
    <Screen
      screenOptions={{
        header: {
          title: 'Quotes',
          backBtnLabel: 'Home',
          backBtnUrl: '/home',
          rightContent: (
            <button className='text-blue-500 dark:text-orange-500 text-xl' onClick={onOpenAddModal}>
              {ICONS.plus}
            </button>
          ),
        },
      }}
    >
      <ScrollableContainer>
        <SectionTitle label='Quotes' className='mb-4' />
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((item) => {
          return (
            <AnimatedBox key={item}>
              <section className='mb-3 p-4 bg-white dark:bg-neutral-800 dark:text-neutral-300 rounded-xl text-sm'>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consequuntur saepe molestiae optio eligendi
                labore praesentium...
              </section>
            </AnimatedBox>
          );
        })}
      </ScrollableContainer>

      {/* <ListApiInfinite<any>
          onSearch={setSearch}
          queryKey={['countries', search]}
          queryFn={({ pageParam }) =>
            BooksService.all({
              page: pageParam,
              search,
              // app_code: appCode,
            })
          }
          renderItem={(item, i) => (
            <div key={i} onClick={() => {}}>
              {item.country}{' '}
            </div>
          )}
        /> */}
    </Screen>
  );
};

export default QuotesListScreen;
